<template>
  <div v-if="dataNotNull" key="1" class="subcontractDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 25px;height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_subcontract">Subcontractors QAQC Non-Conformance</div>
    <div class="zero_subcontract">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {

  name: "subcontract",

  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "subcontract",
      dataNotNull: true,
      proj_dict: {
        "1404": "P00056",
        "1002": "P00034",
        "212": "P00005",
        "249": "P00018"
      }
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },

    analysisResult(result) {
      var subcontracts = []
      var legends = []
      for (var i in result) {
        legends.push(result[i].subcon)
        subcontracts.push(result[i].count)
      }
      return {legends: legends, subcontracts: subcontracts}
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "212"
    }
    this.myChart = echarts.init(document.querySelector('.subcontractDiv .container1'))
    this.myChart.setOption({
      title: {
        text: "Subcontractors QAQC \nNon-Conformance ",
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        show: true,
        trigger: 'axis'
      },
      xAxis: {
        type: "category",
        data: [],
        axisLine: {
          lineStyle: {
            color: '#FFF',
            fontSize: 6
          }
        },
        axisLabel: {
          interval: 0,
          fontSize: 8
        }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: '#6CF'
          }
        }
      },
      series: [{
        data: [],
        barWidth: '25%',
        barCategoryGap: '5%',
        type: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    var proj_id = ''
    if (this.proj_dict[this.my_project_id]) {
      proj_id = this.proj_dict[this.my_project_id]
    } else {
      proj_id = this.my_project_id
    }
    let postData = {
      proj_id: proj_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getDevServer + "DBProjSubNCR", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          xAxis: {
            data: data.legends,
          },
          series: [
            {
              data: data.subcontracts
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })


    // this.init()
  }
}
</script>

<style lang="stylus" scoped>
.title_subcontract
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_subcontract
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/quality/subcontract.vue